<template>
  <Modal :show="true" @close="$emit('close')" class="shop-sync">
    <Card tag="form" class="shop-sync__card" theme="flat" @submit.prevent="submit">
      <template #default>
        <Alert theme="warning" class="mb-2">{{ $t('shopSyncSelectionWarning') }}</Alert>
        <div class="shop-sync__inputs">
          <InputComponent :label="$t('whatDoYouWantToCopy')">
            <template #default>
              <div class="shop-sync__scroller">
                <ChecklistComponent
                  v-model="data.categories"
                  :group-by="{ path: 'category.id', label: 'category.label' }"
                  :items="categories"
                  class="elder-input__element"
                >
                  <CheckboxComponent
                    :value="!data.categories.length"
                    @input="data.categories = []"
                    :label="$t('shopSyncAll')"
                    class="mb-2"
                  />
                </ChecklistComponent>
              </div>
            </template>
          </InputComponent>
          <InputComponent :label="$tc('residential', 2)" data-field="references">
            <template #default>
              <div class="shop-sync__scroller">
                <ChecklistComponent
                  v-model="data.ids"
                  :group-by="{ path: 'project.id', label: 'project.name' }"
                  :items="fetchResidentials"
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>
        </div>
      </template>
      <template #footer>
        <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="$emit('close')" />
        <ButtonComponent
          :label="$t('update')"
          :icon="['fal', 'arrow-to-right']"
          theme="primary"
          type="submit"
          confirm
          :disabled="!data.ids.length"
          :promise="promise"
          @onSuccess="$emit('close')"
        />
      </template>
    </Card>
  </Modal>
</template>

<script>
import { Clone } from '@/utils'
import API from '@/api/Shop'
import ProjectApi from '@/api/Project'

import { ModalComponent as Modal } from 'vue-elder-modal'
import { AlertComponent as Alert } from 'vue-elder-alert'
import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import { CheckboxComponent } from 'vue-elder-checkbox'
import ChecklistComponent from '@/components/Select/Checklist'

const Model = {
  categories: [],
  ids: [],
}

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      data: null,
      promise: null,
    }
  },
  computed: {
    categories() {
      let result = []
      if (!this.value) return new Promise((res, rej) => {})
      const mainCategories = this.value.categories || []
      for (let category of mainCategories.filter(
        cat => cat.tags && !cat.tags.includes('kvass:shop-external-products'),
      )) {
        for (let subcategory of category.categories || []) {
          result.push({
            value: subcategory.id || subcategory.label,
            label: subcategory.label,
            category: {
              id: category.id || category.label,
              label: category.label,
            },
          })
        }
      }
      return result
    },
  },
  methods: {
    submit() {
      let data = { ...this.data }

      this.promise = API.mutate(
        {
          id: this.value.id,
          data,
        },
        {
          transformPayload: false,
          mutation: 'ShopSync',
        },
      )
    },
    fetchResidentials() {
      return ProjectApi.get(
        { filter: { addon: ['project:shop'] }, own: true },
        { query: 'ShopSyncResidentialSearch' },
      ).then(projects => {
        let result = []

        for (let project of projects) {
          for (let residential of project.residentials) {
            result.push({
              value: residential.id,
              label: `${this.$tc('residential')} ${residential.number}`,
              project,
            })
          }
        }

        return result
      })
    },
  },
  created() {
    this.data = Clone(Model)
  },
  components: {
    Card,
    Modal,
    InputComponent,
    CheckboxComponent,
    ChecklistComponent,
    Alert,
  },
}
</script>

<style lang="scss">
.shop-sync {
  &__card {
    width: 100%;
    max-width: 1000px;
  }

  &__scroller {
    max-height: 350px;
    overflow-y: scroll;

    @include scrollShadow();
  }

  &__inputs {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 2rem;
  }
}
</style>
